/* eslint-disable react/prop-types */

import { Divider } from "primereact/divider";

const MetaDataEntity = (props: any) => {
  return (
    <>
      <h2 className="text-lg font-medium my-2">Entity Meta Data</h2>
      <ul className="mt-4">
        {props?.entityMetaData.map((item: any, index: number) => (
          <>
            <li key={index} className="text-sm w-full flex flex-row">
              <span style={{ width: "40%" }}>{item.fieldId}:</span>
              <span
                className=" text-ellipsis overflow-hidden"
                style={{ width: "60%" }}
              >
                {item.value}
              </span>
            </li>
            <Divider />
          </>
        ))}
      </ul>
    </>
  );
};

export default MetaDataEntity;
